import { render, staticRenderFns } from "./ListCaseItem.vue?vue&type=template&id=8cd27b3a&"
import script from "./ListCaseItem.vue?vue&type=script&lang=js&"
export * from "./ListCaseItem.vue?vue&type=script&lang=js&"
import style0 from "./ListCaseItem.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports